import { Spinner } from '@/common/components/spinner';

export function PageLoader() {
  return (
    <div className="flex fixed inset-0 items-center justify-center">
      <Spinner size="lg" />
    </div>
  );
}
